<div *ngIf="loading" class="full">
  <loading i18n="@@front.login.loading">We are logging you in securely</loading>
</div>

<!-- Confrim Email -->
<div *ngIf="is(Status.EmailConfirm)" class="email-confirm">
  <image-text image="assets/images/icons/confirm-email.svg">
    <p class="text" i18n="@@front.login.emailConfirm.description">An email has been sent to {{email.value}}, please click on the confirmation link.</p>
    <div>
      <button (click)="loginAgain()" class="btn btn-outline mb-2" i18n="@@front.login.emailConfirm.backButton">Back to Login Form</button>
      &nbsp;
      <button (click)="submitLoginRequest()" class="btn btn-outline mb-2" i18n="@@front.login.emailConfirm.actionButton">Resend confirmation email!</button>
    </div>
  </image-text>
</div>

<!-- Error -->
<error *ngIf="is(Status.Error)">
  <p class="text" i18n="@@front.login.error.description">Something went wrong please try again</p>
  <button class="btn btn-front btn-primary" (click)="loginAgain()" i18n="@@front.login.error.actionButton">Login Again</button>
</error>

<!-- Login Form -->
<form *ngIf="is(Status.Email)" class="form signin" [formGroup]="loginForm">
  <div *ngIf="error" class="alert alert-warning">{{error}}</div>
  <div *ngIf="!error && ipVerificationResponse" class="alert" [class.alert-success]="ipVerificationResponse.key === ConfirmIpAddressResponseKey.OK" [class.alert-danger]="ipVerificationResponse.key !== ConfirmIpAddressResponseKey.OK">
    {{ipVerificationResponse.message}}
  </div>
  <form-field label="Email" class="front" i18n-label="@@front.login.form.email.label">
    <div class="d-flex align-items-center">
      <input type="email" formControlName="email" placeholder="Your Email Address" class="flex-grow" required i18n-placeholder="@@front.login.form.email.placeholder">
      <img src="assets/images/icons/email.svg" alt="" class="icon">
    </div>
  </form-field>
  <form-field label="Password" class="front mb-2" i18n-label="@@front.login.form.password.label">
    <div class="d-flex align-items-center">
      <input type="password" formControlName="password" placeholder="Your account Password" class="flex-grow" required minlength="6" i18n-placeholder="@@front.login.form.password.placeholder">
      <img src="assets/images/icons/password.svg" alt="" class="icon">
    </div>
  </form-field>

  <div class="text-end mb-4">
    <a routerLink="/forgot-password" i18n="@@front.login.form.forgotPasswordLink">Forget password?</a>
  </div>

  <button type="submit" class="btn btn-front btn-lg btn-primary d-block w-100 mb-3" [disabled]="!loginForm.valid" (click)="onLoginSubmit()">
    <ng-container *ngIf="!loadingCaptcha" i18n="@@front.login.form.submitButton">Login</ng-container>
    <ng-container *ngIf="loadingCaptcha" i18n="@@front.login.form.loading">Loading...</ng-container>
  </button>
  
  <div *ngIf="!loading" class="bg-gray text-center">
    <ng-container i18n="@@front.login.form.signupText">Don’t have an account? <a routerLink="/register">Sign up here</a></ng-container>
  </div>
</form>

<!-- TOTP -->
<form *ngIf="is(Status.TOTP)" class="form totp" [formGroup]="totpForm">
  <div *ngIf="error" class="alert alert-warning">{{error}}</div>
  <p class="text-center" i18n="@@front.login.totp.description">Please enter the TOTP code on your Google authenticator app</p>
  <form-field label="TOTP Code" class="front" i18n-label="@@front.login.totp.code.label">
    <div class="d-flex align-items-center">
      <input type="text" formControlName="code" placeholder="Enter TOTP Code" class="flex-grow" required minlength="6" i18n-placeholder="@@front.login.totp.code.placeholder">
      <img src="assets/images/icons/password.svg" alt="" class="icon">
    </div>
  </form-field>

  <button type="submit" class="btn btn-front btn-lg btn-primary d-block w-100 mb-3" [disabled]="!totpForm.valid" (click)="onTotpSubmit()" i18n="@@front.login.totp.submitButton">Confirm Code</button>
  <div class="text-center">
    <button *ngIf="isSmsEnabled()" (click)="useSms()" class="btn btn-outline">Send an SMS instead</button>
  </div>
</form>

<!-- SMS -->
<form *ngIf="is(Status.OTP)" class="form sms" [formGroup]="smsForm">
  <div *ngIf="error" class="alert alert-warning">{{error}}</div>
  <p class="text-center" i18n="@@front.login.otp.description">We sent a 6 digit verification code to your phone number {{phoneNumber}}</p>
  <form-field label="OTP Code" class="front" i18n-label="@@front.login.otp.code.label">
    <div class="d-flex align-items-center">
      <input type="text" formControlName="code" placeholder="Enter SMS code" class="flex-grow" required minlength="6" i18n-placeholder="@@front.login.otp.code.placeholder" autocomplete="one-time-code">
      <img src="assets/images/icons/password.svg" alt="" class="icon">
    </div>
  </form-field>

  <switch label="Skip SMS verification for 1 month on this computer" i18n-label="@@front.login.otp.rememberMe">
    <input type="checkbox" formControlName="rememberMe">
  </switch>

  <button type="submit" class="btn btn-front btn-lg btn-primary d-block w-100 mb-3" [disabled]="!smsForm.valid" (click)="onOtpSubmit()" i18n="@@front.login.otp.submitButton">Confirm Code</button>
  <div class="text-center">
    <button (click)="useSms()" class="btn btn-outline" i18n="@@front.login.otp.resendSms">Resend SMS code</button>
    <span *ngIf="isCallEnabled()" class="d-inline-block px-2"></span>
    <button *ngIf="isCallEnabled()" (click)="useCall()" class="btn btn-outline" i18n="@@front.login.otp.call">Call me instead</button>
  </div>
</form>